import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import getConfig from "config";

const stripePromise = loadStripe(getConfig().stripePublicKey);

const fonts = [
  {
    cssSrc: "https://fonts.googleapis.com/css?family=Mulish:400"
  }
];

// This needs to wrap the component that injects stripe (i.e. injectStripe HOC)
// https://github.com/stripe/react-stripe-elements#element-groups-elements
export function withStripeElements<P>(Component: React.ComponentType<P>) {
  const WithStripeElements = (props: P) => {
    return (
      <Elements stripe={stripePromise} options={{ fonts }}>
        <ElementsConsumer>
          {({ stripe, elements }) => (
            <Component stripe={stripe} stripeElements={elements} {...props} />
          )}
        </ElementsConsumer>
      </Elements>
    );
  };

  return WithStripeElements;
}
